import { SM } from '../assets/data/enum/storeModel.enum';
import { productionBase } from './base/production.base';

export const environment = {
  ...productionBase,
  themeConfig: {
    ...productionBase.themeConfig,
    brand: 'arvamap',
    textName: 'ARVAmap',
    termsAndCondition: 'https://legal.xfarm.ag/#/terms-and-conditions?l=it&v=latest&b=arvamap',
    privacyPolicy: 'https://legal.xfarm.ag/#/privacy-policy?l=it&v=latest&b=arvamap',
    legalModeBySaas: true,
    forceHideFunctionalityList: [
      // SM.SM_INCABCLOUD_TELEMETRY,
      SM.SM_ANALYTICS_SUSTAINABILITY,
      SM.SM_ANALYTICS_IMPACT,
      SM.SM_ANALYTICS_REGENERATIVE,
      SM.SM_ANALYTICS_OVERVIEW,
      SM.SM_ANALYTICS_CHAIN_MANAGEMENT,
      SM.SM_CONTRACT_MANAGEMENT,
      SM.SM_CONTRACT_AUDIT,
      SM.SM_GUIDE,
      SM.SM_EDUCATION_EDITOR,
      SM.SM_CROP_MAP,
      SM.SM_FARM_DOSSIER,
    ],
    showYaraNPK: false,
    alertPushSelectionEnable: false,
    newsSidebarTabActivation: false,
    advEnable: false,
    versionPublicPage: 'v1',
    welcomeUserCheck: false,
    store: false,
  },
  apiBaseUrl: 'https://api-map.arvatec.it/',
  SSOfrontAppCallback: 'https://map.arvatec.it/#/oauthCheck?token=',
  launchDarklyKey: '676033dfd80564097bceca8a',
  assetsUrl: 'https://cdn.xfarm.ag/webapp/arvamap/',
  palette: {
    '--p-xFarm-xColor-50': '#fff3d6',
    '--p-xFarm-xColor-100': '#ffe7ad',
    '--p-xFarm-xColor-200': '#ffdb84',
    '--p-xFarm-xColor-300': '#fdd059',
    '--p-xFarm-xColor-400': '#f7c51e',
    '--p-xFarm-xColor-500': '#dcaf1f',
    '--p-xFarm-xColor-600': '#c19a1f',
    '--p-xFarm-xColor-700': '#a7851f',
    '--p-xFarm-xColor-800': '#8e711d',
    '--p-xFarm-xColor-900': '#755e1b',
    '--p-xFarm-xColor-950': '#5d4b19',
  },
  primary: '#f7c51e',
  primaryOpacity: '#f7c51e',
  primaryOpacity15: '#f7c51e26',
  secondary: '#ab8919',
  textColorNav: '#333333',
  textColorHeaderTable: '#333333',
  btnSuccess: '#f7c51e',
  backgroundSplashScreen: '#f7c51e',
  navBarColor: '#f7c51e',
  colorSidebarHeader: '#ab8919',
  textColorSidebar: '#333333',
  textLoginVersion: '#FFFFFF',
};
